import {ComponentProps} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Card} from "antd";
import * as api from "../../apis/rebate";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import dayjs from "dayjs";
import DatePicker from "../../components/DatePicker";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {PlatformType, SalesOrderStatusEnum, SalesOrderStatusMapping} from "../../utils/constants";



function RebateTransactions(props:ComponentProps<any>){
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const {tableProps, search, form} = useAntTable(api.getTransactions, {});

    const columns = [
        {
            dataIndex: 'transType',
            title: '交易类型'
        },
        {
            dataIndex: 'salesAt',
            title: '交易时间',
            render(v:any){
                return v && dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'rebateOrderCode',
            title: '返利单号'
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'amount',
            title: '金额'
        },
        {
            dataIndex: 'remainingAmount',
            title: '剩余金额'
        },
        {
            dataIndex: 'salesOrderCode',
            title: '订单号'
        },
        {
            dataIndex: 'salesOrderStatus',
            title: '订单状态',
            render(v:any, r:any){
                return r.salesOrderId?SalesOrderStatusMapping[SalesOrderStatusEnum[v] as any]:null;
            }
        }
    ];

    const adminSearchColumns:StandardColumnsType = [
        {
            dataIndex: 'dealerName',
            title: '客户编号/名称',
            search: true
        },
    ];
    const commonSearchColumns:StandardColumnsType = [
        {
            dataIndex: 'rebateOrderCode',
            title: '返利单号',
            search: true
        },

        {
            dataIndex: 'salesOrderCode',
            title: '销售订单',
            search: true
        },
        {
            dataIndex: 'startDate',
            title: '开始日期',
            search: {
                valueType: 'date',
                valueRender: <DatePicker style={{width: '100%'}}/>
            }
        },
        {
            dataIndex: 'endDate',
            title: '结束日期',
            search: {
                valueType: 'date',
                valueRender: <DatePicker style={{width: '100%'}}/>
            }
        }
    ];
    const searchColumns = platform == PlatformType.Admin ? [...adminSearchColumns, ...commonSearchColumns] : [...commonSearchColumns];


    return <PageHeaderLayout>
            <StandardTable {...tableProps} submit={search.submit} columns={columns} extSearchColumns={searchColumns} form={form} search={search} />
    </PageHeaderLayout>
}

export default RebateTransactions;